<template>
  <li class="node-tree">
    <div v-if="node.label != 'Parent'" class="view-node">
      <span v-if="node.label == 1"> Where</span>
      <span v-else>
        {{ node.form.condition }}
      </span>
      <span class="property">
        {{ node.form.property.property }}
      </span>
      <span class="operator">
        {{ node.form.operator.name }}
      </span>
      <span>{{ node.form.value }}</span>
    </div>

    <ul v-if="node.children && node.children.length">
      <view-tree
        v-for="(child, index) in node.children"
        :node="child"
        :key="index"
      ></view-tree>
    </ul>
  </li>
</template>

<script>
export default {
  name: "view-tree",
  props: {
    node: Object
  }
};
</script>
